import type { Filter, ItemCollectionResponse } from '../types/api';
import type { DependencyAPI } from '../types/dependents';
import { fetchAndParse, filterToQuery } from '../utils/ajax';
import { getTenantId } from '../utils/tenant';

export const getAllDependents = ({ id, filters }: { id: string; filters: Filter }) => {
    const query = filterToQuery(filters);
    return fetchAndParse<ItemCollectionResponse<DependencyAPI>>({
        url: `/api/draw/1/dependents/${id}${query}`,
        method: 'GET',
        headers: {
            ManyWhoTenant: getTenantId(),
        },
    });
};
